const HomeGuest = [
  {
    id: 1,
    link: "https://www.booking.com/searchresults.html?aid=304142&label=gen173nr-1DCAEoggI46AdIM1gEaKsBiAEBmAExuAEXyAEM2AED6AEB-AECiAIBqAIDuAKKpKiTBsACAdICJDk1OTQ3YmFiLTQzYmYtNDQ1ZS1iNjE5LTU3ZWU1NjJkMjUyONgCBOACAQ&sid=2c650482c8c6f75f3aece18e6fa76eb5&dest_id=-553173&dest_type=city&highlighted_hotels=329844&nflt=ht_id%3D219%3Bht_id%3D208%3Bht_id%3D229%3Bht_id%3D227%3Bht_id%3D224%3Bht_id%3D228%3Bht_id%3D214%3Bht_id%3D209%3Bht_id%3D216%3Bht_id%3D210%3Bht_id%3D220%3Bht_id%3D230%3Bht_id%3D215%3Bht_id%3D201%3Bht_id%3D212%3Bht_id%3D213%3Bht_id%3D222%3Bht_id%3D223%3Bht_id%3D232&amp;bhc_from_index=1",
    img: "https://cf.bstatic.com/xdata/images/xphoto/square300/57584488.webp?k=bf724e4e9b9b75480bbe7fc675460a089ba6414fe4693b83ea3fdd8e938832a6&o=",
    title: "Six Continents",
    location: "Prague",
    cost: "12,658",
    rating: "8.8",
    feedback: "Excellent",
    reviews: "347 reviews",
  },
  {
    id: 2,
    link: "https://www.booking.com/searchresults.html?aid=304142&label=gen173nr-1DCAEoggI46AdIM1gEaKsBiAEBmAExuAEXyAEM2AED6AEB-AECiAIBqAIDuAKKpKiTBsACAdICJDk1OTQ3YmFiLTQzYmYtNDQ1ZS1iNjE5LTU3ZWU1NjJkMjUyONgCBOACAQ&sid=2c650482c8c6f75f3aece18e6fa76eb5&dest_id=-666610&dest_type=city&highlighted_hotels=913677&nflt=ht_id%3D219%3Bht_id%3D208%3Bht_id%3D229%3Bht_id%3D227%3Bht_id%3D224%3Bht_id%3D228%3Bht_id%3D214%3Bht_id%3D209%3Bht_id%3D216%3Bht_id%3D210%3Bht_id%3D220%3Bht_id%3D230%3Bht_id%3D215%3Bht_id%3D201%3Bht_id%3D212%3Bht_id%3D213%3Bht_id%3D222%3Bht_id%3D223%3Bht_id%3D232&amp;bhc_from_index=1",
    img: "https://cf.bstatic.com/xdata/images/hotel/max500/74529578.jpg?k=a7fcefd47d7271daf44f6ce78a215b9505f9f8e5cac3af093b78b9c489fd8461&o=",
    title: "Sugar Loft Apartments",
    location: "Rio de Janeiro",
    cost: "6,363",
    rating: "9.1",
    feedback: "Wonderful",
    reviews: "292 reviews",
  },
  {
    id: 3,
    link: "https://www.booking.com/searchresults.html?aid=304142&label=gen173nr-1DCAEoggI46AdIM1gEaKsBiAEBmAExuAEXyAEM2AED6AEB-AECiAIBqAIDuALI-aiTBsACAdICJDY2MmU0NWY1LWU2ODktNDYxNS05NGZhLTQ1OTYxMjQ2MzRhZdgCBOACAQ&sid=2c650482c8c6f75f3aece18e6fa76eb5&dest_id=-96492&dest_type=city&highlighted_hotels=539886&nflt=ht_id%3D220%3Bht_id%3D216%3Bht_id%3D230%3Bht_id%3D227%3Bht_id%3D212%3Bht_id%3D214%3Bht_id%3D209%3Bht_id%3D229%3Bht_id%3D213%3Bht_id%3D201%3Bht_id%3D208%3Bht_id%3D210%3Bht_id%3D228%3Bht_id%3D219%3Bht_id%3D232%3Bht_id%3D215%3Bht_id%3D223%3Bht_id%3D224%3Bht_id%3D222&amp;bhc_from_index=1",
    img: "https://cf.bstatic.com/xdata/images/hotel/max500/77446705.jpg?k=b4137b295019af2a0db1af044c725449adda502a6921fbb2b8931016a8a0a713&o=",
    title: "Villa Domina",
    location: "Split",
    cost: "8,371",
    rating: "9.5",
    feedback: "Exceptional",
    reviews: "1,014 reviews",
  },
  {
    id: 4,
    link: "https://www.booking.com/searchresults.html?aid=304142&label=gen173nr-1DCAEoggI46AdIM1gEaKsBiAEBmAExuAEXyAEM2AED6AEB-AECiAIBqAIDuALI-aiTBsACAdICJDY2MmU0NWY1LWU2ODktNDYxNS05NGZhLTQ1OTYxMjQ2MzRhZdgCBOACAQ&sid=2c650482c8c6f75f3aece18e6fa76eb5&dest_id=-126693&dest_type=city&highlighted_hotels=1257470&nflt=ht_id%3D220%3Bht_id%3D216%3Bht_id%3D230%3Bht_id%3D227%3Bht_id%3D212%3Bht_id%3D214%3Bht_id%3D209%3Bht_id%3D229%3Bht_id%3D213%3Bht_id%3D201%3Bht_id%3D208%3Bht_id%3D210%3Bht_id%3D228%3Bht_id%3D219%3Bht_id%3D232%3Bht_id%3D215%3Bht_id%3D223%3Bht_id%3D224%3Bht_id%3D222&amp;bhc_from_index=1",
    img: "https://cf.bstatic.com/xdata/images/hotel/max500/40890517.jpg?k=cd55de5463af8988f78fd675904a43d02f77570debe9977c4c1fe658030b6d29&o=",
    title: "Appartamento Benincampi",
    location: "Rome",
    cost: "37,348",
    rating: "9.7",
    feedback: "Excellent",
    reviews: "73 reviews",
  },
  {
    id: 5,
    link: "https://www.booking.com/searchresults.html?aid=304142&label=gen173nr-1DCAEoggI46AdIM1gEaKsBiAEBmAExuAEXyAEM2AED6AEB-AECiAIBqAIDuAKKpKiTBsACAdICJDk1OTQ3YmFiLTQzYmYtNDQ1ZS1iNjE5LTU3ZWU1NjJkMjUyONgCBOACAQ&sid=2c650482c8c6f75f3aece18e6fa76eb5&dest_id=-390625&dest_type=city&highlighted_hotels=2471898&nflt=ht_id%3D219%3Bht_id%3D208%3Bht_id%3D229%3Bht_id%3D227%3Bht_id%3D224%3Bht_id%3D228%3Bht_id%3D214%3Bht_id%3D209%3Bht_id%3D216%3Bht_id%3D210%3Bht_id%3D220%3Bht_id%3D230%3Bht_id%3D215%3Bht_id%3D201%3Bht_id%3D212%3Bht_id%3D213%3Bht_id%3D222%3Bht_id%3D223%3Bht_id%3D232&amp;bhc_from_index=1",
    img: "https://cf.bstatic.com/xdata/images/hotel/max500/60109598.jpg?k=dffb396c37f5bf269c311c9d9ef9d65dbefd875027b8aba0f040667e8192a400&o=",
    title: "Godó Luxury Apartment Paseo de Gracia",
    location: "Barcelona",
    cost: "330,333",
    rating: "8.5",
    feedback: "Very Good",
    reviews: "6 reviews",
  },
];

export default HomeGuest;
